export default "__VITE_ASSET__ylrF28a$__"